//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    toRequest () {
      this.$router.replace('/gifts')
      this.close()
    },
    toUpload () {
      this.$router.replace('/gift/new')
      this.close()
    },
    toDonate () {
      this.$router.replace('/needs')
      this.close()
    },
    toInvite () {
      this.$router.push('/invite')
      this.close()
    }
  }
}
